import { Component, Input, OnInit } from '@angular/core';
import { SummaryDataItemModel } from 'src/app/models/summary-data-item-model';

class TempSummaryDataItemModel implements SummaryDataItemModel {
  Title: 'Loading';
  Value: '0';
  OnClick?: null;
}

@Component({
  selector: 'app-summary-totals',
  templateUrl: './summary-totals.component.html',
  styleUrls: ['./summary-totals.component.scss']
})
export class SummaryTotalsComponent implements OnInit {

  @Input()
  summaryData: SummaryDataItemModel[] = [ new TempSummaryDataItemModel() ];

  constructor() {

   } 

  ngOnInit() {
  }

}
